import React, { useState, useEffect } from "react";

import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import gift from "../Assets/Screenshot_2025-01-30_171133-removebg-preview.png";
import gift2 from "../Assets/5141802_51150-removebg-preview.png";
import gift3 from "../Assets/9233781_4111006-removebg-preview.png";
import gift4 from "../Assets/5778630_2954007-removebg-preview.png";
import gift5 from "../Assets/3425156_59858-removebg-preview.png";
import gift6 from "../Assets/20892042_Sandy_Ppl-16_Single-07-removebg-preview.png";
import Aos from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { API_URI } from "../Common/data";
import { Helmet } from "react-helmet";


function OurServices() {

  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [seo, setSeo] = useState({
    title: 'Cine Celebrate - Services',
    metaDescription: '',
    metaKeywords: '',
    canonical: '',
    ogImage: '',
    ogTitle: '',
    ogDescription: '',
    canonicalUrl: ""
  });

  const fetchServices = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URI}/our-services`); // API Endpoint
      if (res.status === 200) {
        setServices(res.data?.data); // Assuming API returns { data: [{name, image}] }
      }
    } catch (error) {
      // toast.error("Error fetching services");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchServices();
  }, []);

  useEffect(() => {
    axios.get(`${API_URI}/page-seo/services`).then(res => {
      if (res.data && res.data.data) setSeo(res.data.data);
    });
  }, []);


  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <>
      {/* <Helmet>
        <title>{seo.title || 'Cine Celebrate - Services'}</title>
        <meta name="title" content={seo.title || 'Cine Celebrate - Services'} />
        <meta name="description" content={seo.description || ''} />
        <meta name="keywords" content={seo.keywords || ''} />
        {seo.canonical && <link rel="canonical" href={seo.canonical} />}
        {seo.ogImage && <meta property="og:image" content={seo.ogImage} />}
      </Helmet> */}

      <Helmet>
        <title>
          {seo.metaTitle && seo.metaTitle.toLowerCase() !== "test services"
            ? seo.metaTitle
            : "Cine Celebrate - Services"}
        </title>
        <meta name="title" content={seo.metaTitle && seo.metaTitle.toLowerCase() !== "test title"
          ? seo.metaTitle
          : "Cine Celebrate - Services"} />
        <meta
          name="description"
          content={
            seo.metaDescription && seo.metaDescription.toLowerCase() !== "test description"
              ? seo.metaDescription
              : "Explore our exclusive celebration and event services at Cine Celebrate."
          }
        />
        <meta
          name="keywords"
          content={seo?.metaKeywords && Array.isArray(seo?.metaKeywords) ? seo?.metaKeywords.join(", ") : "Private Theater, Celebration, Cine Celebrate"}
        />
        <link rel="canonical" href={seo?.canonicalUrl} />
        <meta property="og:title" content={seo?.ogTitle} />
        <meta property="og:description" content={seo?.ogDescription} />
        <meta property="og:image" content={seo?.ogImage} />
      </Helmet>
      <Navbar />
      <div className="news-banner news-banner2">
        <p>Services</p>
        <br />
        <h1>Our Services</h1>
      </div>
      <div className="services">
        {/* <div className="service-card" data-aos="fade-right" data-aos-duration="3000">
          <div className="service-card-left">
            <h3>Private Theater Booking</h3>
            <br />
            <p>
              Enjoy your own theater space to watch movies, shows, photos, or
              videos with your loved ones.
            </p>
          </div>
          <div className="service-card-right">
            <img src={gift} />
          </div>
        </div> */}
        <br />
        <br />
        {/* <div className="service-card service-card2">
          <div className="service-card-right">
            <img src={gift2} />
          </div>
          <div className="service-card-left">
            <h3>Food & Beverages</h3>
            <br />
            <p>
              Treat yourself and your guests to a variety of delicious snacks
              and drinks during the celebration.
            </p>
          </div>
        </div> */}
        {
          services.length > 0 && services.map((service, index) => (
            <div
              className={`service-card ${index % 2 !== 0 ? "service-card2" : ""}`}
              data-aos="fade-right"
              data-aos-duration="3000"
              key={index}
            >

              {index % 2 === 0 ? (
                <>
                  <div className="service-card-left">
                    <h2>{service.heading}</h2>
                    <br />
                    <p>{service.description}</p>
                  </div>
                  <div className="service-card-right">
                    <img src={service.image} alt={service.heading} />
                  </div>
                </>
              ) : (

                <>
                  <br />
                  <>
                    <div className="service-card-right">
                      <img src={service.image} alt={service.heading} />
                    </div>
                    <div className="service-card-left service-card-left-text">
                      <h2>{service.heading}</h2>
                      <br />
                      <p >{service.description}</p>
                    </div>
                  </>
                </>
              )}
            </div>
          ))

        }

        {/* <br />
        <br />

        <div className="service-card" data-aos="fade-right" data-aos-duration="3000">
          <div className="service-card-left">
            <h3>Event Customization</h3>
            <br />
            <p>
              Personalize your celebration with add-ons like gifts,
              decorations, and themed setups.
            </p>
          </div>
          <div className="service-card-right">
            <img src={gift3} />
          </div>
        </div>
        <br />
        <br />
        <div className="service-card service-card2" data-aos="fade-right" data-aos-duration="3000">
          <div className="service-card-right">
            <img src={gift4} />
          </div>
          <div className="service-card-left">
            <h3>Photoshoot Services</h3>
            <br />
            <p>
              Capture beautiful memories with professional photoshoots to make
              your event truly special.
            </p>
          </div>
        </div>
        <br />
        <br />

        <div className="service-card" data-aos="fade-right" data-aos-duration="3000">
          <div className="service-card-left">
            <h3>Occasion-Based Packages</h3>
            <br />
            <p>
              Choose from tailored packages for birthdays, anniversaries, date
              nights, bride-to-be parties, and more.
            </p>
          </div>
          <div className="service-card-right">
            <img src={gift5} />
          </div>
        </div>
        <br />
        <br />
        <div className="service-card service-card2" data-aos="fade-right" data-aos-duration="3000">
          <div className="service-card-right">
            <img src={gift6} />
          </div>
          <div className="service-card-left">
            <h3>Hassle-Free Celebration</h3>
            <br />
            <p>
              We handle the setup, service, and cleanup so you can relax and
              enjoy the event.
            </p>
          </div>
        </div> */}
      </div>
      <Footer />
    </>
  );
}

export default OurServices;
